// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--3zCYC","links":"footer-module--links--pXoBZ","copyrightLink":"footer-module--copyright-link--2zcK7"};